import { apiPostModel, postApi } from '../../../useApiHook';

export const createClinicianMileageCap = (auth, entityModel, callback) => {
  const postModel = apiPostModel('CreateClinicianMileageCap', entityModel, callback);
  postApi(auth, postModel);
};

export const createOrEditNonPatientActivityType = (auth, entityModel, callback) => {
  const enpointName = entityModel.Id > 0 ? 'EditNonPatientActivityType' : 'CreateNonPatientActivityType';
  const postModel = apiPostModel(enpointName, entityModel, callback);
  postApi(auth, postModel);
};

export const importPatient = (auth, model, callback, errorCallback) => {
  const postModel = apiPostModel('ImportPatient', model, callback, errorCallback);
  postApi(auth, postModel);
};
